"use client";

import { CiCircleAlert, CiMap, CiTrophy } from "react-icons/ci";
import {
  HiNoSymbol,
  HiOutlineBookOpen,
  HiOutlineClipboardDocumentCheck,
  HiOutlineCog8Tooth,
  HiOutlineDocumentDownload,
  HiOutlinePresentationChartBar,
  HiOutlineQuestionMarkCircle,
  HiOutlineUserGroup
} from "react-icons/hi2";
import { HiOutlineClipboardList } from "react-icons/hi";
import {
  IoBarChartOutline,
  IoBookOutline,
  IoBusinessOutline,
  IoCallOutline,
  IoChatbubbleOutline,
  IoClipboardOutline,
  IoDocumentOutline,
  IoDocumentTextOutline,
  IoDownloadOutline,
  IoFlagOutline,
  IoFlashOutline,
  IoHelpCircleOutline,
  IoHomeOutline,
  IoListOutline,
  IoNavigateCircleOutline,
  IoPeopleOutline,
  IoPersonAddOutline,
  IoPersonOutline,
  IoRibbonOutline,
  IoStatsChartOutline,
  IoTimeOutline,
} from "react-icons/io5";
import { LiaLayerGroupSolid, LiaTheaterMasksSolid } from "react-icons/lia";

import { FaBroadcastTower } from "react-icons/fa";
import { AiOutlineHighlight } from "react-icons/ai";
import { RiPlayList2Fill } from "react-icons/ri";
import { RxTarget } from "react-icons/rx";
import { SlGraduation } from "react-icons/sl";

export const IconMapping = {
  HiOutlineBookOpen,
  HiOutlineClipboardDocumentCheck,
  ClipboardList: HiOutlineClipboardList,
  HiOutlineCog8Tooth,
  HiOutlineQuestionMarkCircle,
  IoDocumentOutline,
  IoFlagOutline,
  IoFlashOutline,
  IoDocumentTextOutline,
  IoPeopleOutline,
  IoStatsChartOutline,
  CiMap,
  HiOutlinePresentationChartBar,
  HiOutlineUserGroup,
  HiNoSymbol,
  LiaTheaterMasksSolid,
  IoClipboardOutline,
  IoListOutline,
  IoNavigateCircleOutline,
  IoPersonOutline,
  IoHomeOutline,
  CiTrophy,
  CiCircleAlert,
  SlGraduation,
  IoBookOutline,
  IoBusinessOutline,
  IoCallOutline,
  RxTarget,
  FaBroadcastTower,
  LiaLayerGroupSolid,
  IoBarChartOutline,
  IoPersonAddOutline,
  IoTimeOutline,
  RiPlayList2Fill,
  IoChatbubbleOutline,
  IoHelpCircleOutline,
  IoRibbonOutline,
  IoDownloadOutline,
  AiOutlineHighlight
};
